<template>
  <div v-if="final_quiz" class="final-quiz-available-component">
    <div class="d-flex align-items-center justify-content-center">
      <div
        class="d-flex flex-column flex-lg-row justify-content-center text-center text-lg-left"
      >
        <i
          v-if="isBlocked"
          class="fa-solid fa-lock-keyhole mr-lg-4 mb-4 mb-lg-0"
        ></i>
        <i v-else class="fa-solid fa-file-pen mb-4 mr-lg-4 mb-lg-0"></i>
        <div>
          <h5 v-if="isFinished || isBlocked" class="mb-0 pb-0">
            Avaliação final
          </h5>
          <h5 v-else class="mb-0 pb-0">Avaliação final disponível</h5>
          <p v-if="isFinished" class="mt-2 mb-0">{{ finishedMsg }}</p>
          <p v-else-if="isBlocked" class="mt-2 mb-0">{{ blockedMsg }}</p>
          <p v-else-if="!isBlocked" class="mb-0">
            <button class="btn btn-sm p-0 m-0" @click="quiz_visible = true">
              Clique aqui
            </button>
            e responda o questionário{{ messageFinalQuiz }}
          </p>
        </div>
      </div>
    </div>
    <quiz-modal
      v-if="quiz_visible"
      v-model="quiz_visible"
      :quiz="final_quiz"
      @close="quiz_visible = false"
    />
  </div>
  <div v-else></div>
</template>
<script>
import { removeTimeZone } from "@/functions/helpers";
import QuizModal from "@/components/lesson/quiz/QuizModal";
import get from "lodash/get";
export default {
  components: { QuizModal },
  data() {
    return {
      final_quiz: null,
      quiz_visible: false
    };
  },
  mounted() {
    this.dispatch();
  },
  computed: {
    isFinished() {
      return get(this.final_quiz, "progress.finished_at", false);
    },
    finishedMsg() {
      const finished = get(this.final_quiz, "progress.finished_at", false);
      if (finished) {
        const date = new Date(removeTimeZone(finished));
        return `Prova finalizada em: ${date.toLocaleDateString()}`;
      }

      return "";
    },
    isBlocked() {
      return this.final_quiz.is_blocked || !this.isReleased;
    },
    isReleased() {
      return this.final_quiz.release_at
        ? new Date(removeTimeZone(this.final_quiz.release_at)).getTime() <
            new Date().getTime()
        : true;
    },
    blockedMsg() {
      const today = new Date();
      const created_at = new Date(this.$user.course.date_joined);
      const release_date = new Date(
        created_at.setDate(
          created_at.getDate() + this.final_quiz.days_to_release
        )
      );
      let message = "";
      if (today < release_date) {
        message = `Atenção: sua avaliação só será liberada no dia ${release_date.toLocaleDateString()}.`;
      } else if (this.final_quiz.release_at && !this.isReleased) {
        message = `Atenção: sua avaliação só será liberada no dia ${new Date(
          removeTimeZone(this.final_quiz.release_at)
        ).toLocaleDateString()}.`;
      } else {
        message =
          "Atenção: sua avaliação só será liberada após a conclusão de todas as aulas dos módulos do seu curso.";
      }

      return message;
    },
    messageFinalQuiz() {
      return this.$setup.setup.minimum_quiz_progress > 0
        ? ", ele será avaliado e valerá para obtenção do certificado."
        : ".";
    }
  },
  methods: {
    dispatch() {
      this.$store.dispatch("quiz/getQuizFinal").then(data => {
        this.final_quiz = data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.final-quiz-available-component {
  padding: 16px 16px 24px 16px;
  border-radius: 8px;

  .icon-area {
    text-align: end;
    @media screen and (max-width: 992px) {
      text-align: center;
    }
  }

  .text-area {
    text-align: start;
    @media screen and (max-width: 992px) {
      text-align: center;
    }
  }
  .fa-file-pen,
  .fa-lock-keyhole {
    font-size: 48px;
    color: #6b3ead;
  }

  h5 {
    font-weight: 500;
    font-size: 18px;
    @media screen and (max-width: 992px) {
      font-size: 16px;
    }
  }

  p,
  p > * {
    font-size: 16px;
    line-height: 16px;
    button {
      padding: 0 !important;
      margin: 0 !important;
      font-weight: 400 !important;
      display: inline-block;
      color: inherit;
      text-decoration: underline;
    }
    @media screen and (max-width: 992px) {
      font-size: 14px;
    }
  }
}
</style>
